module.exports = __webpack_public_path__ + "img/bookcity_active.png";